import React from 'react'
import { Card } from 'antd'
import QuestionsTable from './QuestionsTable'
import QuestionDrawer from '../drawer/QuestionDrawer'
import questionSelectors from '../../../../../store/selectors/question.selectors'
import { useSelector } from 'react-redux'
import { isNumber } from 'lodash'
import assignmentSelectors from '../../../../../store/selectors/assignment.selectors'
import CompareWithLmsButton from '../compare-with-lms/CompareWithLmsButton'
import QuestionDefinitionActions from '../question-definition/QuestionDefinitionActions'
import CreateQuestionButton from './CreateQuestionButton'
import { isMba } from '../../../../../utils/assignment.helper'
import { useFetchTextAssignmentSubmissionsQuery } from '../../../../../store/apis/submission.api'
import { useParams } from 'react-router'
import { useVersionId } from '../../../../../utils/parseURL.helper'

const QuestionsCard = () => {
    const { token } = useParams()
    const versionId = useVersionId()
    const editingQuestionId = useSelector(questionSelectors.editingQuestionId)
    const lmsEnabled = useSelector(assignmentSelectors.lmsEnabled)
    const assignmentType = useSelector(assignmentSelectors.type)
    const { data: submissions, isFetching: isFetchingSubmissions } = useFetchTextAssignmentSubmissionsQuery({
        token,
        versionId,
    })

    return (
        <Card
            title='Questions'
            extra={
                <>
                    {!isMba(assignmentType) && !isFetchingSubmissions && !submissions?.length && (
                        <>
                            <CreateQuestionButton />
                        </>
                    )}
                    <QuestionDefinitionActions />
                    {lmsEnabled && <CompareWithLmsButton />}
                </>
            }
        >
            <QuestionsTable />
            {isNumber(editingQuestionId) && <QuestionDrawer />}
        </Card>
    )
}

export default QuestionsCard
